const buildConnectionUrlParams = (page, hash) => new URLSearchParams({
  name: 'user-disconnected',
  page,
  hash,
  referrer: window.location.href
}).toString();

function buildConnectionUrl(routeMapper, hostUrl, page, hash) {
  const routerUrl = routeMapper[hostUrl];

  if (!routerUrl) {
    throw new Error("No route found for hostUrl: " + hostUrl);
  }

  const connectionUrlParams = buildConnectionUrlParams(page, hash);
  return routerUrl.includes('?') ? routerUrl + "&" + connectionUrlParams : routerUrl + "?" + connectionUrlParams;
}

const buildMessage = _ref => {
  let {
    type,
    hash,
    page,
    returningUser
  } = _ref;
  return {
    name: type,
    payload: {
      hash,
      returningUser
    },
    page,
    referrer: "" + window.location.href
  };
};

export { buildConnectionUrl, buildMessage };
//# sourceMappingURL=utils.js.map